import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=2cffe394&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"
import style0 from "./MyTasks.vue?vue&type=style&index=0&id=2cffe394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffe394",
  null
  
)

export default component.exports